import styled from "styled-components";

import { EmptyState } from "@similarweb/ui-components";

export const StyledCrmEmptyState = styled(EmptyState)`
    padding: 24px 12px;
    text-align: center;
    height: auto;
`;
